<lib-ags-loading *ngIf="loader"></lib-ags-loading>
<div
  *ngIf="!infoEvaluation.length && !loader"
  class="uk-overflow-auto uk-margin-large-right
  notfoundApprenant
  uk-margin-medium-bottom"
>
  Pas d'apprenant(s) pour cette session
</div>
<div *ngIf="!!infoEvaluation.length && !loader" class="uk-card-default evaluation-content">
  <kendo-panelbar (stateChange)="changeITem($event)" [expandMode]="expandMode" class="all-items-primary-background">
    <kendo-panelbar-item
      [id]="item.id_session_apprenant.toString()"
      *ngFor="let item of infoEvaluation; let i = index"
      [title]="item.nom"
      [expanded]="i === 0"
    >
      <ng-template class="bloc" kendoPanelBarContent>
        <div [class]="'custom-template'">
          <table class="uk-table uk-table-small uk-table-divider">
            <tr>
              <th width="100">COMPÉTENCE</th>
              <th width="450">DESCRIPTION</th>
              <th width="150">
                <input
                  [ngModel]="item.status[0]"
                  (change)="toggleSatisfactionStatus(0, item)"
                  type="checkbox"
                  class="checkbox"
                />
                <span class="text-overflow-ellipis">Non acquis</span>
              </th>
              <th width="200">
                <input
                  [ngModel]="item.status[1]"
                  (change)="toggleSatisfactionStatus(1, item)"
                  type="checkbox"
                  class="checkbox"
                />
                <span class="text-overflow-ellipis"> Partiellement acquis</span>
              </th>
              <th width="100">
                <input
                  [ngModel]="item.status[2]"
                  (change)="toggleSatisfactionStatus(2, item)"
                  type="checkbox"
                  class="checkbox"
                />
                <span class="text-overflow-ellipis">Acquis</span>
              </th>
            </tr>
            <tr *ngFor="let competence of item.sessionApprenantCompetences">
              <td>{{ competence.competence_libelle }}</td>
              <td>{{ competence.competence_description }}</td>
              <td>
                <label>
                  <input
                    (change)="satisfactionChanged(item, competence, 0)"
                    [ngModel]="competence.acquis_peu_satisfaisant"
                    type="checkbox"
                    class="checkbox"
                  />
                  <button
                    *ngIf="competence.acquis_peu_satisfaisant"
                    style="margin-left: .2rem; margin-right: .3rem;"
                    [primary]="true"
                    (click)="openDialog(competence)"
                    kendoButton
                    class="primary-background"
                  >
                    Motif
                  </button>
                  <span></span>
                </label>
              </td>
              <td>
                <label>
                  <input
                    (change)="satisfactionChanged(item, competence, 1)"
                    [ngModel]="competence.acquis_satisfaisant"
                    type="checkbox"
                    class="checkbox"
                  />
                  <span></span>
                </label>
              </td>
              <td>
                <label>
                  <input
                    (change)="satisfactionChanged(item, competence, 2)"
                    [ngModel]="competence.acquis_tres_satisfaisant"
                    type="checkbox"
                    class="checkbox"
                  />
                  <span></span>
                </label>
              </td>
            </tr>
            <tr>
              <td>ÉVALUATION FINALE</td>
              <td></td>
              <td>
                <label>
                  <input
                    (change)="evaluationFinaleChanged(item, 0)"
                    [ngModel]="item.evaluation_finale_peu_satisfaisant"
                    type="checkbox"
                    class="checkbox"
                  />
                  <span> Non evalué</span>
                </label>
              </td>
              <td>
                <label>
                  <input
                    (change)="evaluationFinaleChanged(item, 1)"
                    [ngModel]="item.evaluation_finale_satisfaisant"
                    type="checkbox"
                    class="checkbox"
                  />
                  <span> Echec</span>
                </label>
              </td>
              <td>
                <label>
                  <input
                    (change)="evaluationFinaleChanged(item, 2)"
                    [ngModel]="item.evaluation_finale_tres_satisfaisant"
                    type="checkbox"
                    class="checkbox"
                  />
                  <span> Réussite</span>
                </label>
              </td>
            </tr>
          </table>

          <div class="upload-component" uk-grid>
            <div class="uk-width-1-5"></div>
            <div class="uk-card-default card-content uk-width-2-5">
              <ags-document-management
                (updateList)="getEvaluationInfo(idSession)"
                [listInfoDoc]="item.document.documents"
                [listUrlDoc]="item.document.url"
              >
              </ags-document-management>
            </div>
            <div class="card-content uk-width-2-5">
              <lib-ags-upload-file (amzoneInfo)="uploadInfo($event)"></lib-ags-upload-file>
            </div>
          </div>
          <div
            *ngIf="errorServer"
            [@alertDisplay]=""
            class="invalid-feedback-value k-text-center font-size-100 k-text-center"
            role="alert"
          >
            <strong>Impossible</strong> d'ajouter le fichier, veuillez réessayer plus tard.
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>

<kendo-dialog
  [title]="titleDialog"
  *ngIf="openedMotifiDialog"
  (close)="closeMotifDialog()"
  [minWidth]="250"
  [width]="1000"
>
  <br />
  <ng-container *ngTemplateOutlet="contentDialog"></ng-container>
</kendo-dialog>
<ng-template #contentDialog>
  <kendo-editor [value]="valueMotif" (valueChange)="changeMotif($event)">
    <kendo-toolbar>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
      <kendo-toolbar-buttongroup>
        <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
        <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
      </kendo-toolbar-buttongroup>
    </kendo-toolbar>
  </kendo-editor>
  <br />
  <button
    kendoButton
    (click)="addMotif()"
    type="submit"
    class="k-button k-primary uk-margin-medium-bottom"
    style="float: right;"
  >
    Valider
  </button>
</ng-template>
